<template>
  <v-container style="width:100%">
    <v-layout row wrap>
      <v-flex xs12 sm6 class="ml-4 py-2">
        <v-btn
          :outline="currentView == 'products' ? false : true"
          color="primary"
          @click="changeView('products')"
          small
        >
          {{ $t('Products') }}
        </v-btn>
        <v-btn
          :outline="currentView == 'wholesale' ? false : true"
          color="primary"
          @click="changeView('wholesale')"
          small
        >
          {{ $t('All Wholesale') }}
        </v-btn>
        <v-btn
          :outline="currentView == 'promotion' ? false : true"
          color="primary"
          @click="changeView('promotion')"
          small
        >
          {{ $t('Coupon') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <component :is="currentView"></component>
  </v-container>
</template>

<script>
import api from '@/api'
import Products from './Products.vue'
import Wholesale from './Wholesale.vue'
import Promotion from './Promotion.vue'
export default {
  computed: {},
  data: function() {
    return {
      currentView: 'products'
    }
  },
  created() {},
  mounted() {
    const vm = this
    let localView = localStorage.getItem('currentView')
    if (localView === 'products') {
      vm.currentView = 'products'
    } else if (localView === 'wholesale') {
      vm.currentView = 'wholesale'
    } else if (localView === 'promotion') {
      vm.currentView = 'promotion'
    } else {
      vm.currentView = 'products'
    }
  },
  components: {
    Products,
    Wholesale,
    Promotion
  },
  methods: {
    changeView(view) {
      const vm = this
      let setView = localStorage.setItem('currentView', view)
      vm.currentView = view
    }
  },
  watch: {}
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ButtonCategories.vue